<template>
    <div>
        <div style="padding:20px 0; height:30px; font-size:50px;">
            <b>{{this.company}}</b>
        </div>
        <br><br><br>
        <b class="title">About</b>
        <div id="about" style="height:300px;"></div>
        <br><br><br>
        <b class="title">How it works(graph, functions, video)</b>
        <div id="how" style="height:300px;"></div>
        <br><br><br>
        <b class="title">Supported products/Versions</b>
        <div id="supported" style="height:300px;"></div>
        <br><br><br>
        <b class="title">Manual</b>
        <div id="manual" style="height:300px;"></div>
        <br><br><br>
        <div style="float:right;">
                <el-button @click="submit()" type="primary">Submit</el-button>
        </div>
        <br><br><br><br>
    </div>
</template>
<script>
export default {
    props:{
        id:{}
    },
    data () {
        return {
            about:"",
            how:"",
            supported:"",
            manual:"",
            company:""
        };
    },
    mounted () {
        this.createEditor("about");
        this.createEditor("how");
        this.createEditor("supported");
        this.createEditor("manual");
        this.getInfo();
    },
    methods:{
        createEditor (val) {
            let E = window.wangEditor;
            this[val] = new E('#'+val);
            this[val].customConfig.zIndex = 100;
            this[val].customConfig.uploadImgShowBase64 = true;
            this[val].customConfig.uploadFileServer = `${this.$http.host}partnerManageServer/uploadDownloadFileTechnologyPartners`;
            this[val].customConfig.downloadFileServer = `${this.$http.host}akuvoxwiki/download/partnerManage/productMaterials`;
            this[val].create();
        },
        getInfo () {
            this.$http.get("getTechnologyPartnerCompanyInfo",{
                TechnologyPartners:this.id
            },(data)=>{
                data = data.data;
                this.company = data.Company;
                this.about.txt.html(data.About);
                this.how.txt.html(data.How);
                this.supported.txt.html(data.Supported);
                this.manual.txt.html(data.Manual);
            });
        },
        submit () {
            this.$http.put("editTechnologyPartnerCompany",{
                TechnologyPartners:this.id,
                About:this.about.txt.html(),
                How:this.how.txt.html(),
                Supported:this.supported.txt.html(),
                Manual:this.manual.txt.html()
            },(data)=>{
                this.$baseNotice.message(data.msg);
                this.$router.push(`/technologyPartner`);
            });
        }
    }
};
</script>
<style lang="less" scoped>
    .title{
        padding: 25px 0 5px 0;
        display: block;
    }
</style>

